// src/components/ShippingRecord/AddDisputePopin/DisputeFormInfo.tsx
import React from "react";
import { useFormContext } from "react-hook-form";
import clsx from "clsx";
import CField, { CFieldInputProps } from "$forms/CField";
import GenericSelect from "$forms/GenericSelect";
import { ShippingRecordDisputeType } from "$types";
import { useStyles } from "../styles";
import { useDisputeForm } from "../context/DisputeFormContext";
import { EditMode } from "../hooks/useDisputeFormLogic";

export const DisputeFormInfo: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const classes = useStyles();

  const {
    editMode,
    type,
    opsWithNoDispute,
    deliveryLocationsWithNoDispute,
    shippingRecordDisputeTypeOptions,
  } = useDisputeForm();

  return (
    <>
      <div className={classes.lineContainer}>
        <div className={classes.inputContainer}>
          <CField
            label="Type"
            name="type"
            control={control}
            required
            disabled={editMode !== EditMode.CREATE}
            error={errors.type}
          >
            {(props: CFieldInputProps) => (
              <GenericSelect
                {...props}
                options={shippingRecordDisputeTypeOptions}
              />
            )}
          </CField>
        </div>
        <div
          className={clsx(
            classes.inputContainer,
            classes.linkedEntityContainer
          )}
        >
          {type === ShippingRecordDisputeType.PREPARATION_ORDER && (
            <CField
              label="OP concerné"
              name="linkedEntityId"
              control={control}
              required
              disabled={editMode !== EditMode.CREATE}
              error={errors.linkedEntityId}
            >
              {(props: CFieldInputProps) => (
                <GenericSelect {...props} options={opsWithNoDispute} />
              )}
            </CField>
          )}
          {type === ShippingRecordDisputeType.DELIVERY && (
            <CField
              label="Lieu de livraison concerné"
              name="linkedEntityId"
              control={control}
              required
              disabled={editMode !== EditMode.CREATE}
              error={errors.linkedEntityId}
            >
              {(props: CFieldInputProps) => (
                <GenericSelect
                  {...props}
                  options={deliveryLocationsWithNoDispute}
                />
              )}
            </CField>
          )}
        </div>
      </div>
      <div className={classes.lineContainer}>
        <div className={classes.inputContainer}>
          <CField
            label="Litige"
            disabled={editMode === EditMode.READ_ONLY}
            name="text"
            control={control}
            multiline
            variant="outlined"
            maxRows={10}
            minRows={5}
            error={errors.text}
          />
        </div>
      </div>
    </>
  );
};
